/* HeyBear · FAQ (homepage): scroll reveal. Questions use native <details> open/close. */
HB.section('faq', function (root) { HB.reveal(root); });
